<template>
  <div>
    <g-master name="ocasionales"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :actions="false"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
      <template slot="expandedRowRender" slot-scope="{text}">
        <template v-for="ve in master.valoresExpandidos">
          {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
        </template>
      </template>
    </g-master>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        fileNameExcel: 'novedades_oca_hist',
        paramsT: {},
        endpointExcel: 'oca_novedades_hist/downloadExcel',
        master: {
          valoresExpandidos: [
            {label: 'Moneda Liq', column: 'currency'},
            {label: 'Proceso', column: 'prc'},
            {label: 'Centro de Costo', column: 'cc_name'},
            {label: 'Estado', column: 'status_desc'},
            {label: 'Descripción', column: 'description'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'},
            {label: 'Creado por hist', column: 'created_by_hist'},
            {label: 'Creado hist', column: 'created_on_hist'}
          ],
          endpoint: 'oca_hist',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'novelty_id'
            },
            columns: [
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre Completo', dataIndex: 'full_name', sorter: true},
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Unidad', dataIndex: 'oca_und', sorter: true, align: 'right'},
              {title: 'Vlr Base', dataIndex: 'oca_base', sorter: true, align: 'right'},
              {title: 'Vlr Local', dataIndex: 'oca_valor_l', sorter: true, align: 'right'},
              {title: 'Fecha Liquidación', dataIndex: 'oca_date_liq_mask', sorter: true},
              {title: 'Fecha Novedad', dataIndex: 'oca_date_reg_mask', sorter: true},
              {title: 'Documento', dataIndex: 'oca_document', sorter: true}
            ],
            actions: {
              actions: []
            }
          },
          modalFieldsSetup: [
            {name: 'created_by'},
            {name: 'created_on'},
            {name: 'currency'},
            {name: 'description'},
            {name: 'fliq'},
            {name: 'id_cc'},
            {name: 'id_coc'},
            {name: 'id_emp'},
            {name: 'modified_by'},
            {name: 'modified_on'},
            {name: 'novelty_id'},
            {name: 'oca_apl'},
            {name: 'oca_base'},
            {name: 'oca_date_liq'},
            {name: 'oca_date_reg'},
            {name: 'oca_date_system'},
            {name: 'oca_document'},
            {name: 'oca_tmp'},
            {name: 'oca_und'},
            {name: 'oca_usuario'},
            {name: 'oca_valor'},
            {name: 'oca_valor_l'},
            {name: 'prc'},
            {name: 'status'}
          ],
          actions: []
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/OcaHist.vue